import type { Character } from '../domain/character.ts';

export const LIBRARY_INDEX_VERSION = 1;

/** One row in the Character Library list. Cheap to load; never authoritative. */
export interface LibraryEntry {
  id: string;
  name: string;
  crawlerType: 'human' | 'animal';
  level: number;
  floor: number;
  updatedAt: string;
}

export interface LibraryIndex {
  version: number;
  entries: LibraryEntry[];
}

export function emptyIndex(): LibraryIndex {
  return { version: LIBRARY_INDEX_VERSION, entries: [] };
}

export function entryFor(character: Character): LibraryEntry {
  return {
    id: character.id,
    name: character.name,
    crawlerType: character.crawlerType,
    level: character.level,
    floor: character.floor,
    updatedAt: character.updatedAt,
  };
}

export function upsertEntry(index: LibraryIndex, entry: LibraryEntry): LibraryIndex {
  const entries = index.entries.filter((e) => e.id !== entry.id);
  entries.push(entry);
  entries.sort((a, b) => a.name.localeCompare(b.name));
  return { version: LIBRARY_INDEX_VERSION, entries };
}

export function removeEntry(index: LibraryIndex, id: string): LibraryIndex {
  return { version: LIBRARY_INDEX_VERSION, entries: index.entries.filter((e) => e.id !== id) };
}

export function isLibraryIndex(value: unknown): value is LibraryIndex {
  if (typeof value !== 'object' || value === null) return false;
  const v = value as Record<string, unknown>;
  return typeof v['version'] === 'number' && Array.isArray(v['entries']);
}
